<template>
  <el-row class="banner-row">
    <el-col :xs="24" :sm="16" style="margin: auto;">
      <el-row class="banner-row-2">
        <el-col :xs="24" :sm="12" class="banner-left">
          <div class="banner-box">
            <div class="left-image">
              <img
                class="bannerlogo"
                src="@/assets/bannerlogo.png"
              />
              <img
                class="image-title"
                src="@/assets/slogin.png"
              />
            </div>
            <div class="left-but">
              <div class="android-but">
                <img class="but-logo"
                  src="@/assets/alogo.png"
                />
                <img class="but-logo-hover"
                  src="@/assets/alogo-2.png"
                />
                <div class="but-desc">
                  <label>Android</label>
                  <label>客户端</label>
                </div>
              </div>
              <div class="ios-but">
                <img class="but-logo"
                  src="@/assets/plogo.png"
                />
                <img class="but-logo-hover"
                  src="@/assets/plogo-2.png"
                />
                <div class="but-desc">
                  <label>IOS & iPadOS</label>
                  <label>客户端</label>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="0" :sm="12" class="banner-right">
          <img
            class="right-image"
            src="@/assets/banneriphone.png"
          />
        </el-col>
      </el-row>
    </el-col>
  </el-row>
  <el-row>
    <el-col :xs="24" :sm="14" style="margin: auto;">
      <div class="content">
        <div class="title-h1">丰富商品，满足您的一切需求</div>
        <div class="title-desc">柚优品汇集全球精选商品，从日常用品到奢侈品，应有尽有，让您一站式购齐</div>
        <div class="card-box">
          <div class="card">
            <!-- <div class="info"></div> -->
            <div class="bg"></div>
          </div>
          <div class="card">
            <div class="bg"></div>
          </div>
          <div class="card">
            <div class="bg"></div>
          </div>
          <div class="card">
            <div class="bg"></div>
          </div>
        </div>
        <div class="title-h1">100%正品保障，放心购物</div>
        <div class="title-desc">我们承诺所有商品均为正品，严格把控供应链，让您买得安心，用得放心</div>
        <div class="title-carousel">
          <div class="left">
            <div class="row1">
              <div class="title2">
                <img
                  class="title2-image"
                  src="@/assets/leaf.png"
                />
                <div>品牌直供</div>
              </div>
              <div class="title2-desc">
                与全球知名品牌建立直接合作关系，所有商品均由品牌方或授权经销商提供，从源头上确保正品。
              </div>
            </div>
            <div class="row1">
              <div class="title2">
                <img
                  class="title2-image"
                  src="@/assets/leaf.png"
                />
                <div>严格质检</div>
              </div>
              <div class="title2-desc">
                每件商品入库前均经过专业质检团队严格检查，确保商品质量符合标准，杜绝假冒伪劣产品。
              </div>
            </div>
            <div class="row1">
              <div class="title2">
                <img
                  class="title2-image"
                  src="@/assets/leaf.png"
                />
                <div>七天无理由退换</div>
              </div>
              <div class="title2-desc">
                购买后7天内，如对商品不满意，在不影响二次销售的情况下，可申请无理由退换货，让您购物无忧。
              </div>
            </div>
            <div class="attention">*注：部分商品不支持七天无理由退换货请知悉</div>
          </div>
          <div class="right">
            <el-carousel indicator-position="none" height="469px">
              <el-carousel-item>
                <img
                  class="carousel-image"
                  src="@/assets/ad-1.png"
                />
              </el-carousel-item>
              <el-carousel-item>
                <img
                  class="carousel-image"
                  src="@/assets/ad-2.png"
                />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        
        <div class="title-h1">用户的真实评价</div>
        <div class="title-desc">来自柚优品用户的真实体验分享，看看他们怎么说</div>
        <div class="evaluate">
          <div class="card">
            <div class="info">
              <img
                class="bg-image"
                src="@/assets/copy.png"
              />
              <img
                class="bg-image2"
                src="@/assets/copy2.png"
              />

              <img
                class="star-image"
                src="@/assets/star.png"
              />
              <div class="star-title">在柚优品买过好几次化妆品了，和专柜买的一样，价格更优惠。物流非常快，客服态度很好，推荐购买！</div>
              <div class="star-user">
                <img
                  class="user-image"
                  src="@/assets/mswang.png"
                />
                <div class="user-info">
                  <label>王女士</label>
                  <label>美妆爱好者</label>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="info">
              <img
                class="bg-image"
                src="@/assets/copy.png"
              />
              <img
                class="bg-image2"
                src="@/assets/copy2.png"
              />

              <img
                class="star-image"
                src="@/assets/star.png"
              />
              <div class="star-title">作为一个数码控，我很在意产品的真伪。在柚优品买的手机验过了是正品，价格比官网便宜，还有赠品，满意！</div>
              <div class="star-user">
                <img
                  class="user-image"
                  src="@/assets/mrli.png"
                />
                <div class="user-info">
                  <label>李先生</label>
                  <label>资深数码控</label>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="info">
              <img
                class="bg-image"
                src="@/assets/copy.png"
              />
              <img
                class="bg-image2"
                src="@/assets/copy2.png"
              />

              <img
                class="star-image"
                src="@/assets/star.png"
              />
              <div class="star-title">作为时尚博主，我对服饰品质要求很高柚优品的设计师品牌服饰款式新颖，和我在时装周看到的同款，性价比超高！</div>
              <div class="star-user">
                <img
                  class="user-image"
                  src="@/assets/mscchen.png"
                />
                <div class="user-info">
                  <label>陈女士</label>
                  <label>时尚达人</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :xs="24" :sm="24" style="background-color: #2B2B2B; margin: 112px 0 0 0;">
      <el-row class="bottom">
        <el-col :xs="24" :sm="7">
          <div class="but">
            <img
              class="down-image"
              src="@/assets/android.png"
            />
            <img
              class="down-image"
              src="@/assets/ios.png"
            />
          </div>
        </el-col>
        <el-col :xs="0" :sm="7">
          <img
            class="bottom-image"
            src="@/assets/bottomiphone.png"
          />
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>

export default {
  name: 'HomeView',
}
</script>

<style lang="scss" scoped>
.banner-row {
  // background-color: #F2DDC5;
  background: radial-gradient(circle, #F1DBC2 0%, #F5F2ED 100%);
  // padding-bottom: 88px;
  .banner-row-2 {
    background-image: url(@/assets/banenrbg.png);
    background-position: center; /* 居中背景图 */
    background-repeat: no-repeat; /* 不重复背景图 */
    background-size: cover; /* 覆盖整个元素，保持图片比例不变 */
    .banner-left ,.banner-right {
      margin: 56px 0 0;
    }
    .banner-left {
      padding: 35px 0 0;
      display: flex;
      flex-flow: row-reverse;
      
      .banner-box {
        display: inline-block;
      }
      .image-title {
        margin: 35px 0 27px;
        max-width: 319px;
        width: 100%;
      }
      .bannerlogo {
        max-width: 181px;
        width: 100%;
        display: block;
        margin: auto;
      }

      .left-but {
        display: flex;
        justify-content: center;
        flex-flow: row;
        .android-but ,.ios-but {
          display: flex;
          flex-flow: row;
          // padding: 10px 0px 10px 22px;
          background-color: #fff;
          border-radius: 68px;
          height: 68px;
          width: 200px;
          align-items: center;
          padding: 0 0 0 20px;
          color: #552600;
          img {
            margin-right: 18px;
          }
          .but-logo-hover {
            display: none;
          }
          .but-logo {
            display: block;
          }
        }
        .android-but:hover ,.ios-but:hover {
          border: 1px solid #A77952;
          background-color: rgba(242,223,207,0.55);
          box-shadow: 0px 0px 15px 3px rgba(242,223,207,0.55);
          
          .but-logo-hover {
            display: block;
          }
          .but-logo {
            display: none;
          }
        }
        .ios-but img {
          width: 42px;
          height: 50px;
        }
        .android-but {
          margin: 0 21px 0 0;
          img {
            width: 40px;
            height: 46px;
          }
        }
        .but-desc {
          display: flex;
          flex-flow: column;
          justify-content: center;
          text-align: left;
        }
      }
    }
    .right-image {
      max-width: 451px;
      width: 100%;
    }
  }
}

.content {
  padding: 69px 0 0 0;
  font-family: PingFang SC;
  text-align: center;
  .title-h1 {
    color: #552600;
    font-weight: 500;
    font-size: 24px;
  }
  .title-desc {
    color: #ABA49F;
    font-size: 18px;
  }
  .card-box {
    margin: 40px auto 70px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    justify-content: center;
    .card {
      background-position: center; /* 居中背景图 */
      background-repeat: no-repeat; /* 不重复背景图 */
      background-size: cover; /* 覆盖整个元素，保持图片比例不变 */
      overflow: hidden;
      width: 288px;
      height: 376px;
      position: relative;
      margin-right: 5px;
      .bg {
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 3;
        top: 376px;
        -webkit-transition: all .3s;
        transition: all .3s;
        background-position: center; /* 居中背景图 */
        background-repeat: no-repeat; /* 不重复背景图 */
        background-size: cover; /* 覆盖整个元素，保持图片比例不变 */
      }
    }
    :hover .bg {
      top: 0;
    }
    :nth-child(1) {
      background-image: url(@/assets/ad1.png);
      .bg {
        background-image: url(@/assets/ad1-2.png);
      }
    }
    :nth-child(2) {
      background-image: url(@/assets/ad2.png);
      .bg {
        background-image: url(@/assets/ad2-2.png);
      }
    }
    :nth-child(3) {
      background-image: url(@/assets/ad3.png);
      .bg {
        background-image: url(@/assets/ad3-2.png);
      }
    }
    :nth-child(4) {
      background-image: url(@/assets/ad4.png);
      margin-right: 0px;
      .bg {
        background-image: url(@/assets/ad4-2.png);
      }
    }
  }
  .title-carousel {
    margin: 40px 0 80px 0;
    display: flex;
    flex-flow: row;
    justify-content: center;
    .left {
      width: 608px;
      margin: 0 56px 0 0;
      .title2 {
        display: flex;
        justify-items: center;
        font-weight: 500;
        font-size: 20px;
        color: #552600;
        margin: 26px 0 12px;
        .title2-image {
          width: 21px;
          margin-right: 8px;
        }
      }
      .title2-desc {
        font-size: 16px;
        color: #3E3E3E;
        text-align: left;
      }
      .attention {
        font-size: 14px;
        color: #CA9772;
        text-align: left;
        margin-top: 27px;
      }
    }
    .right {
      width: 506px;
      .carousel-image {
        width: 506px;
      }
    }
  }

  .evaluate {
    margin: 40px 0 0 0;
    display: flex;
    justify-content: center;
      height: 345px;
    .card {
      width: 376px;
      height: 342px;
      box-shadow: 0px 0px 10px 1px rgba(218, 215, 213, 0.55);
      margin: 0 24px 0 0;
      .info {
        position: relative;
        padding: 45px 35px 0;
        .bg-image {
          position: absolute;
          top: 32px;
          left: 23px;
          width: 44px;
        }
        .bg-image2 {
          position: absolute;
          top: 172px;
          right: 35px;
          width: 44px;
          // z-index: -1;
        }
        .star-image {
          z-index: 1;
          position: relative;
        }
        .star-title {
          font-size: 14px;
          color: #444444;
          text-align: left;
          margin: 40px 0 0 0;
          position: relative;
          z-index: 1;
        }
        .star-user {
          display: flex;
          margin: 32px 0 0 0;
          img.user-image {
            width: 56px;
            margin: 0 32px 0 0;
          }
          .user-info {
            display: flex;
            flex-flow: column;
            justify-content: center;
            text-align: left;
            font-size: 14px;
            :nth-child(2) {
              color: #ABA49F;
            }
          }
        }
      }
    }
    .card:hover {
      background-color: #FFFBF7;
      border: 2px solid #F1D4C0;
    }
  } 
}

.bottom {
  width: 100%;
  justify-content: center;
  padding: 0 0 15px 0;
  .but {
    display: flex;
    flex-flow: column;
    justify-content: center;
    height: 100%;
    padding: 0 0 0 80px;
    .down-image {
      width: 232px;
    }
    :nth-child(1) {
      margin-bottom: 42px;
    }
  }
  .bottom-image {
    width: 586px;
    margin-top: -23px;
  }
}

@media (max-width: 2560px) {
  .android-but ,.ios-but {
    font-size: 18px !important;
  }
  .title-h1 {
    font-size: 36px !important;
  }
  
  .title-desc {
    font-size: 28px !important;
  }
  .card-box {
    margin: 54px auto 97px !important;
    .card {
      width: 384px !important;
      height: 500px !important;
      .bg {
        top: 500px !important;
      }
    }
    
    :hover .bg {
      top: 0 !important;
    }
  }

  .title-carousel {
    margin: 54px 0 108px 0 !important;
    justify-content: space-between;
    .left {
      width: 823px !important;
      margin: 0 75px 0 0 !important;
      .title2 {
        font-size: 28px !important;
        // margin: 29px 0 24px !important;
        .title2-image {
          width: 32px !important;
          margin-right: 6px !important;
        }
      }
      .title2-desc {
        font-size: 20px !important;
      }
      .attention {
        font-size: 20px !important;
      }
    }
    .right {
      width: 674px !important;
      .carousel-image {
        width: 674px !important;
      }
    }
  }

  .bottom {
    .but {
      padding: 0 0 0 106px !important;
      .down-image {
        width: 309px !important;
      }
      :nth-child(1) {
        margin-bottom: 56px !important;
      }
    }
    .bottom-image {
      width: 780px !important;
      margin-top: -26px !important;
    }
  }


  .evaluate {
    margin: 54px 0 0 0 !important;
    height: 460px !important;
    justify-content: space-between;

    .card {
      width: 500px !important;
      height: 455px !important;
      // margin: 0 32px 0 0 !important;
      .info {
        padding: 64px 46px 0 !important;
        .bg-image {
          top: 42px !important;
          left: 31px !important;
          width: 58px !important;
        }
        .bg-image2 {
          top: 229px !important;
          right: 47px !important;
          width: 58px !important;
        }
        .star-title {
          margin: 52px 0 0 0 !important;
          font-size: 20px !important;
        }
        .star-user {
          margin: 42px 0 0 0 !important;
          .user-info {
            font-size: 20px !important;
          }
          img.user-image {
            width: 88px !important;
            margin: 0 37px 0 0 !important;
          }
        }
      }
    }
  }

}

@media (max-width: 1920px) {
  .android-but ,.ios-but {
    font-size: 16px !important;
  }
  .title-h1 {
    font-size: 24px !important;
  }
  
  .title-desc {
    font-size: 18px !important;
  }
  .card-box {
    margin: 27px auto 49px !important;
    .card {
      width: 288px !important;
      height: 376px !important;
      // width: 192px !important;
      // height: 250px !important;
      .bg {
        top: 376px !important;
      }
    }
    :hover .bg {
      top: 0 !important;
    }
  }

  .title-carousel {
    margin: 27px 0 60px 0 !important;
    .left {
      width: 608px !important;
      // width: 406px !important;
      margin: 0 38px 0 0 !important;
      .title2 {
        font-size: 20px !important;
        margin: 29px 0 24px !important;
        .title2-image {
          width: 21px !important;
          margin-right: 8px !important;
        }
      }
      .title2-desc {
        font-size: 16px !important;
      }
      .attention {
        font-size: 14px !important;
      }
    }
    .right {
      width: 506px !important;
      // width: 338px !important;
      .carousel-image {
        width: 506px !important;
      }
    }
  }

  .bottom {
    .but {
      padding: 0 0 0 53px !important;
      .down-image {
        width: 155px !important;
      }
      :nth-child(1) {
        margin-bottom: 28px !important;
      }
    }
    .bottom-image {
      width: 391px !important;
      margin-top: -16px !important;
    }
  }


  .evaluate {
    margin: 27px 0 0 0 !important;
    height: 345px !important;
    .card {
      width: 376px !important;
      height: 342px !important;
      // width: 228px !important;
      // height: 250px !important;
      margin: 0 16px 0 0 !important;
      .info {
        padding: 32px 23px 0 !important;
        .bg-image {
          top: 21px !important;
          left: 16px !important;
          width: 29px !important;
        }
        .bg-image2 {
          top: 115px !important;
          right: 24px !important;
          width: 29px !important;
        }
        .star-image {
          width: 153px !important;
        }
        .star-title {
          margin: 26px 0 0 0 !important;
          font-size: 16px !important;
        }
        .star-user {
          margin: 22px 0 0 0 !important;
          .user-info {
            font-size: 16px !important;
          }
          img.user-image {
            width: 44px !important;
            margin: 0 20px 0 0 !important;
          }
        }
      }
    }
  }

}

// @media (max-width: 768px) {
//   .banner-row {
//     padding-bottom: 30px;
//     .banner-row-2 {
//       background-image: url(@/assets/banenrbg.png);
//       background-position: center; /* 居中背景图 */
//       background-repeat: no-repeat; /* 不重复背景图 */
//       background-size: cover; /* 覆盖整个元素，保持图片比例不变 */
//       .banner-left ,.banner-right {
//         margin: 23px 0 0;
//       }
//       .banner-left {
//         padding: 38px 0 0;
//         .image-title {
//           margin: 23px 0 18px;
//           max-width: 213px;
//           width: 100%;
//         }
//         .bannerlogo {
//           max-width: 120px;
//           width: 100%;
//         }
//       }
//       .right-image {
//         max-width: 300px;
//         width: 100%;
//       }
//     }
//   }

// }
</style>
